<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="customerRegion"
      [label]="'case.fields.customerRegion.label' | translate"
      [helpText]="'case.fields.customerRegion.help'"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('customerRegion')?.value || ''
      }"
      [entry]="entry1"
      (onSelectEvent)="onSelectField($event, dropdownTypeEnum.CUSTOMER_REGION)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="customerSite"
      [label]="'case.fields.customerSite.label' | translate"
      [helpText]="'case.fields.customerSite.help'"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="customerNameSiteData"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('customerRegion')?.value || '',
        entry2: '',
        entry3: form.get('customerSite')?.value || '',
      }"
      [entry]="entry3"
      (onSelectEvent)="onSelectField($event, dropdownTypeEnum.CUSTOMER_SITE)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="customerContactName"
      [label]="'case.fields.customerContactName.label' | translate"
      [helpText]="'case.fields.customerContactName.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="customerContactPhone"
      [label]="'case.fields.customerContactPhone.label' | translate"
      [helpText]="'case.fields.customerContactPhone.help'"
      [viewMode]="viewMode"
      [patternText]="'label.invalid_phone_number' | translate"
      [translatable]="false"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="customerContactEmail"
      [label]="'case.fields.customerContactEmail.label' | translate"
      [helpText]="'case.fields.customerContactEmail.help'"
      [infoText]="'label.please_type_na_if_not_applicable' | translate"
      [viewMode]="viewMode"
      [errorText]="errorTextCustomerContactEmail"
      [translatable]="false"
      (onChangeEvent)="customerContactEmailValueChange($event)"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="customerContactRole"
      [label]="'case.fields.customerContactRole.label' | translate"
      [helpText]="'case.fields.customerContactRole.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  @if(extended || caseId) {
  <div class="col-12 col-md-6">
    <app-select-form-field
      formControlName="customerCountry"
      [users]="false"
      [label]="'case.fields.customerCountry.label' | translate"
      [helpText]="'case.fields.customerCountry.help'"
      [bindLabel]="'value'"
      [bindValue]="'value'"
      [items]="customerCountryItems"
      [placeholder]="''"
      [viewMode]="viewMode"
    ></app-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-select-form-field
      formControlName="customerGlobalName"
      [users]="false"
      [label]="'case.fields.customerGlobalName.label' | translate"
      [helpText]="'case.fields.customerGlobalName.help'"
      [bindLabel]="'value'"
      [bindValue]="'value'"
      [items]="customerGlobalNameItems"
      [placeholder]="''"
      [viewMode]="viewMode"
    ></app-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-select-form-field
      formControlName="smaFactoryName"
      [users]="false"
      [label]="'case.fields.smaFactoryName.label' | translate"
      [helpText]="'case.fields.smaFactoryName.help'"
      [bindLabel]="'value'"
      [bindValue]="'value'"
      [items]="smaFactoryNameItems"
      [placeholder]="''"
      [viewMode]="viewMode"
    ></app-select-form-field>
  </div>
  }
</div>
